import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { LifeLevel as Desc } from './desk'
import { LifeLevel as Mob } from './mob'

type Props = {
  images: TImages
}
export const LifeLevel: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob images={images} /> : <Desc images={images} />
}
